<script>
import {
  adminRegistrationComputed,
  adminRegistrationMethods,
} from '@state/helpers/admin-registration'
import { nameListComputed, nameListMethods } from '@state/helpers/name-list'
import { STATUS_REQUEST } from '@utils/constant'
import cloneDeep from 'lodash/cloneDeep'
import registrationItems from './registrationItems'

export default {
  page: {
    title: 'Registration Admin',
    meta: [{ name: 'description', content: 'The Registration Admin page.' }],
  },
  data() {
    return {
      items: null,
      title: this.$t('pages.adminRegistration'),
      optionsLevel: [
        {
          id: 1,
          label: 'サブ管理者',
          value: 2,
        },
        {
          id: 2,
          label: '閲覧者',
          value: 3,
        },
        {
          id: 3,
          label: '広告配信者',
          value: 4,
        },
      ],
    }
  },
  computed: {
    ...adminRegistrationComputed,
    ...nameListComputed,
    nameListComputed() {
      const options = cloneDeep(this.getNameList)
      return options?.list?.map((item) => {
        return { value: item.id, label: item.company }
      })
    },
    errorServerSideComputed() {
      return this.getErrors
    },
  },
  watch: {
    getStatus() {
      if (this.getStatus === STATUS_REQUEST.SUCCESS) {
        this.resetRegistrationAdmin()
        this.backToListPage()
      }
    },
    nameListComputed() {
      this.items.map((item) => {
        if (item.key === 'agent_id') {
          item.options = this.nameListComputed
          item.value = item.options[0].value
        } else if (item.key === 'level') {
          item.options = this.optionsLevel
          item.value = item.options[0].value
        }
      })
    },
  },
  created() {
    this.fetchingNameList()
  },
  mounted() {
    this.initItems()
  },
  methods: {
    ...adminRegistrationMethods,
    ...nameListMethods,
    initItems() {
      this.items = cloneDeep(registrationItems)
    },
    handleAddNewAdmin() {
      const payload = this.items.reduce((results, item) => {
        results[item.key] = item.value
        return results
      }, {})
      this.registrationAdmin(payload)
    },
    handleCancel() {
      this.initItems()
      this.backToListPage()
    },
    backToListPage() {
      this.$router.push({ path: '/panel/admin-list' })
    },
    isRequiredPassword(data) {
      return !(data.trim() === '' && data.length > 0)
    },
    isComfirmedPassword(key) {
      const field = {
        passwordConfirm: 4,
        password: 3,
      }
      if (this.items[field[key]].value === '') {
        return false
      } else {
        return key
      }
    },
  },
}
</script>

<template>
  <BaseAddNewCard
    :errors="errorServerSideComputed"
    type="add"
    @submit="handleAddNewAdmin"
    @cancel="handleCancel"
  >
    <template v-slot:header>
      <h5 class="card-title">{{ title }}</h5>
    </template>
    <template v-slot>
      <CRow v-for="item in items" :key="item.key">
        <CCol sm="3">
          {{ item.label }}
          <span v-if="item.rules" class="text-danger">*</span>
        </CCol>
        <CCol sm="9">
          <BaseSelect
            v-if="item.as === 'select'"
            :rules="item.rules"
            :name="item.name"
            :vee-name="item.name"
            :options="item.options"
            :value.sync="item.value"
          />
          <BaseInput
            v-if="item.as === 'input' && item.key === 'password'"
            v-model="item.value"
            :rules="{
              required: isRequiredPassword(item.value),
              password: true,
            }"
            :name="item.name"
            :vee-name="item.name"
            :type="item.type"
            autocomplete="new-password"
          />
          <BaseInput
            v-if="item.as === 'input' && item.key === 'password_2'"
            v-model="item.value"
            :rules="{
              required: isRequiredPassword(item.value),
              password: true,
              confirmed: isComfirmedPassword('password'),
            }"
            :name="item.name"
            :vee-name="item.name"
            :type="item.type"
            autocomplete="new-password"
          />
          <BaseInput
            v-if="item.as === 'input' && item.key === 'admin_name'"
            v-model="item.value"
            :rules="{
              required: item.value.length <= 0,
              adminID: true,
            }"
            :name="item.name"
            :vee-name="item.name"
            :type="item.type"
          />
          <BaseInput
            v-if="item.as === 'input' && item.key === 'admin_display_name'"
            v-model="item.value"
            :rules="{
              required: true,
              min: 1,
              max: 100,
            }"
            :name="item.name"
            :vee-name="item.name"
            :type="item.type"
          />
        </CCol>
      </CRow>
    </template>
  </BaseAddNewCard>
</template>

<style lang="scss" scoped>
.card-title {
  margin-bottom: 0 !important;
  font-weight: 600;
  color: #73818f;
}
</style>
